import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';

class CustomerIO {
  CIO: AnalyticsBrowser;

  init() {
    if (this.CIO) {
      return;
    }

    this.CIO = AnalyticsBrowser.load(
      { writeKey: process.env.customerIO_CDP_KEY },
      {
        integrations: {
          'Customer.io In-App Plugin': {
            siteId: process.env.customerIO_SITE_ID,
            anonymousInApp: true,
          },
        },
      }
    );
  }

  identify(...params: Parameters<AnalyticsBrowser['identify']>) {
    if (this.CIO) {
      this.CIO.identify(...params);
    }
  }

  trackPage() {
    if (this.CIO) {
      this.CIO.page();
    }
  }
}

export const CustomerIOManager = new CustomerIO();
